import Instance from "../../../Axios";

const GetAllClients = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/clients/profiles`)
    .then(({ data }) => {
      dispatch({ type: "GET_ALL_CLIENTS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAllClients;
